import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin, Result, Button } from 'antd';

const PrivateRoute = ({ children }) => {
  const { user, userType, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  // 未登录，跳转到登录页
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 已登录但不是管理员，显示无权限页面
  if (userType !== 'admin') {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有权限访问此页面。管理员后台仅限管理员账户访问。"
        extra={
          <Button type="primary" href="/activate">
            前往客户激活页面
          </Button>
        }
      />
    );
  }

  return children;
};

export default PrivateRoute;
